export function ServiceFees() {
    return (
        <>
            <table>
                <tbody>
                <tr>
                    <td><h4>Wire Transfers</h4>Wiring cash to us or from us to another financial institution.</td>
                    <td>No charge</td>
                </tr>
                <tr>
                    <td><h4>Full Account Transfer Out Fee</h4>Applied when you transfer your entire account to another brokerage firm.</td>
                    <td>$100 per account</td>
                </tr>
                <tr>
                    <td><h4>Partial Account Transfer Out Fee</h4>Applied when you transfer some of the securities (e.g., stocks) in your account to another brokerage without selling the securities.</td>
                    <td>$5 per security<br/>($25 min / $75 max)</td>
                </tr>
                <tr>
                    <td><h4>Checkbooks</h4>We reserve the right to charge a per-check fee if you write more than a specific number of checks each month.</td>
                    <td>No charge</td>
                </tr>
                <tr>
                    <td><h4>Returned Check</h4>Applied when there is a returned check request due to non-sufficient funds (NSF).</td>
                    <td>$35 per occurrence</td>
                </tr>
                <tr>
                    <td><h4>Returned EFT</h4>Applied when there is a failed electronic funds transfer (EFT) request.</td>
                    <td>$10 per occurrence</td>
                </tr>
                <tr>
                    <td><h4>Stop Payment on Check</h4></td>
                    <td>$35 per check</td>
                </tr>
                <tr>
                    <td><h4>Uncashed Stale-Dated Check Fee</h4></td>
                    <td>$20 per check</td>
                </tr>
                <tr>
                    <td><h4>Check Copy</h4></td>
                    <td>$20 per check</td>
                </tr>
                <tr>
                    <td><h4>Check Withdrawal-Standard mail</h4></td>
                    <td>No charge</td>
                </tr>
                <tr>
                    <td><h4>Express Mail</h4></td>
                    <td>$30 per mailing, M-F delivery.<br/>$45 per mailing, Sat delivery</td>
                </tr>
                <tr>
                    <td><h4>Option Servicing Fee</h4></td>
                    <td>$0 per trade and $0.65 per contract</td>
                </tr>
                <tr>
                    <td><h4>ADR Fees</h4>Certain ADRs may be subject to service fees designed to compensate the agent bank performing the custodial services. The fees are charged periodically and typically range from between $.01 to $.03 per share.</td>
                    <td>The ADR prospectus will provide specific information on applicable fees.</td>
                </tr>
                <tr>
                    <td><h4>Corporate Actions</h4>Participating in corporate actions, such as when you participate in voluntary tender offers. There is no charge for mandatory actions, such as mergers or acquisitions.</td>
                    <td>No charge</td>
                </tr>
                <tr>
                    <td><h4>Charge for Special Services</h4>Hourly charges apply when you require services not covered by the charges above, such as location research when customer contact information is outdated. A minimum one hour charge applies to all requests.</td>
                    <td>$250</td>
                </tr>
                <tr>
                    <td><h4>Trading Service Fees</h4>Fees to offset regulatory and transaction costs imposed on brokers relating to buy and sell transactions in certain securities.</td>
                    <td>Adjusted periodically</td>
                </tr>
                <tr>
                    <td>
                        <h4>Mutual Fund Fees</h4>
                        We currently offer no-load mutual funds. We may impose a commission charge for handling these mutual funds. Most mutual funds have early redemption fees and investment minimums. Please note that most mutual funds charge management, marketing and administration fees that are deducted directly from fund assets. We receive compensation from certain mutual fund companies for the recordkeeping, shareholder services, and other administrative services that we provide to shareholders of the funds. These shareholder services include transaction processing, settlement of trades, dividend distribution, record maintenance, and distribution of statements, confirmations, prospectuses and other regulatory shareholder documents.<br/><br/>
                        Early Redemption Fees assessed by mutual funds vary by fund. Please consult your prospectus for applicable charges.
                    </td>
                    <td>Fees vary by fund</td>
                </tr>
                <tr>
                    <td><h4>Alternative Investment Transfer Fees</h4>Fees to offset costs imposed on us by funds to transfer your shares to another custodian.</td>
                    <td>Fees vary by fund</td>
                </tr>
                <tr>
                    <td><h4>IRA Custodial Fee</h4>For each IRA custodial account we will apply this fee annually, or when you close your IRA if this fee has not already been applied for the calendar year.</td>
                    <td>$25 per year</td>
                </tr>
                <tr>
                    <td><h4>Residual Balance Fee</h4>Quarterly fee applied to closed accounts under closed memberships that still have a balance. This fee or the lesser of the remaining account balance will be charged quarterly.</td>
                    <td>$15</td>
                </tr>
                <tr>
                    <td>
                        <h4>Debit Cards</h4>
                        Information regarding Debit Card Transaction Receipts can be found in your Customer Agreement.<br/><br/>
                        ADDITIONAL TERMS APPLICABLE TO CERTAIN EFTs<br/><br/>
                        Stop Recurring Payments on Money Transfers and Bill Payments. If you have authorized us or any other persons in advance to initiate periodically recurring debits to your Brokerage Account by means of EFTs, you can stop any of these payments online through our website or by calling your Advisor.<br/><br/>
                        Here's how: Call us 1-888-230-5635, or write us at: gs-custodysolutions@gs.com, in time for us to receive your request three (3) business days or more before the payment is scheduled to be made. If you call, we may also require you to put your request in writing and get it to us within 14 days after you call. We may charge you a fee for each stop-payment order you give, as disclosed in the Fee Schedule.<br/><br/>
                        Copies of Sales Draft (Available upon request).<br/><br/>
                        Additional information regarding your debit card is available in the account level view.<br/><br/>
                        The Card Providers may charge you a per-transaction fee (including a fee for a balance inquiry, even if you do not complete an ATM transaction) if you exceed more than a specified number of ATM transactions each year, as indicated in the Fee Schedule.<br/><br/>
                        In addition, if you undertake any ATM or point of sale transaction using the Debit Card outside of the United States or purchase goods or services from a merchant located outside of the United States, Visa may impose additional fees - such fees will be identified by UMB or on the Fee Schedule.
                    </td>
                    <td>
                        No charges<br/><br/>
                        No fee for ATM Domestic or International Withdrawal<br/><br/>
                        Additional fees: ATM owner might charge a surcharge fee at time of usage. Fee will be credited back to client's GSAS account when the cash withdrawal transaction is posted to client account.
                    </td>
                </tr>
                </tbody>
            </table>
        </>
    );
}
